import React from 'react';
import CustomModal from '../CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';
import CustomButton from '../CustomButton/CustomButton';
import {ArrowUpward} from '@material-ui/icons';

type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 670,
    padding: theme.spacing(4, 2, 1, 2),
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    // margin: theme.spacing(2),
  },
  description: {
    textAlign: 'center',
    fontSize: '0.875rem',
    color: colors.grey800,
  },

  tierRestrictionModalText: {
    color: colors.grey700,
    fontSize: '0.875rem',
    lineHeight: '22px',
  },
  button: {
    height: 40,
    // marginTop: theme.spacing(2),
    fontSize: '1rem',
    fontWeight: 600,
    padding: '6px 50px',
  },
  tierRestrictionModalContent: {
    marginBlock: '1rem',
  },
  iconWrap: {
    fontSize: '1.25rem',
    width: 100,
    height: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    margin: '1rem auto',
    background: colors.lightPurple,
    color: colors.purple,
  },
}));

export default function FeatureRestrictionModal({open, handleClose}: Props) {
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Esta característica no está incluida en tu plan actual
        </Typography>
        <Typography className={classes.description}>
          Mejora tu plan para empezar a utilizarla y muchas más.
        </Typography>

        <div className={classes.tierRestrictionModalContent}>
          <span className={classes.iconWrap}>
            <ArrowUpward fontSize="large" />
          </span>
        </div>

        <CustomButton
          variant="contained"
          className={classes.button}
          to="/tiers-list"
          onClick={handleClose}
        >
          Ver planes
        </CustomButton>
        <CustomButton onClick={handleClose}>Cerrar</CustomButton>
      </div>
    </CustomModal>
  );
}
